import Header from "components/Headers/Header";
import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
  Button,
  Form,
} from "reactstrap";
import { useParams } from "react-router-dom";
import Cookies from "universal-cookie";

import EditaVehiculoOrden from "./EditaVehiculoOrden";
import EditaPropietarioOrden from "./EditaPropietarioOrden";
import EditaEquiposOrden from "./EditaEquiposOrden";
import EditaAnexosOrden from "./EditaAnexosOrden";

const EditaOrden = () => {
  const { idOrden } = useParams();
  const cookie = new Cookies();

  const [data, setData] = useState({});
  const [tipoOrdenes, setTipoOrdenes] = useState([]);
  const [listasChequeo, setListasChequeo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [propietarioRes, tipoOrdenesRes, listasRes] = await Promise.all([
          fetch(
            `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerPropietariosPorVehiculo/${idOrden}`,
          ),
          fetch(
            "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerTipoOrdenes",
          ),
          fetch(
            "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerListas",
          ),
        ]);

        const propietarioData = await propietarioRes.json();
        const tipoOrdenesData = await tipoOrdenesRes.json();
        const listasChequeoData = await listasRes.json();

        if (!propietarioData.length) {
          throw new Error("No se encontró información de la orden");
        }

        setData(propietarioData[0]);
        setTipoOrdenes(tipoOrdenesData);
        setListasChequeo(listasChequeoData);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [idOrden]);

  const handleChange = ({ target: { name, value } }) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ActualizaOrdenes/${idOrden}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        },
      );

      const message = await response.text();
      alert(message);

      if (!response.ok) {
        throw new Error(message);
      }
    } catch (err) {
      alert("Error actualizando la orden");
    }
  };

  if (loading) return <div>Cargando información...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <>
      <Header />

      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader>
                <div className="text-center font-weight-bold">Editar Orden</div>
              </CardHeader>

              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label>Fecha Conversión</label>
                        <Input
                          type="date"
                          name="fechaConversion"
                          value={data.fechaConversion || ""}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="6">
                      <FormGroup>
                        <label>Fecha Creación</label>
                        <Input
                          type="text"
                          name="fechaCreacion"
                          value={data.fechaCreacion || ""}
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="6">
                      <FormGroup>
                        <label>Tipo Orden</label>
                        <Input
                          type="select"
                          name="tipoOrdenServicioId"
                          value={data.tipoOrdenServicioId || ""}
                          onChange={handleChange}
                        >
                          <option value="">Seleccione</option>
                          {tipoOrdenes.map((o) => (
                            <option key={o.id} value={o.id}>
                              {o.nombre}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg="6">
                      <FormGroup>
                        <label>Lista de Chequeo</label>
                        <Input
                          type="select"
                          name="listaChequeoId"
                          value={data.listaChequeoId || ""}
                          onChange={handleChange}
                        >
                          <option value="">Seleccione</option>
                          {listasChequeo.map((l) => (
                            <option key={l.id} value={l.id}>
                              {l.nombre}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg="6">
                      <FormGroup>
                        <label>Estado</label>
                        <Input
                          type="select"
                          name="estado"
                          value={data.estado || ""}
                          onChange={handleChange}
                        >
                          <option value="">Seleccione</option>
                          <option value="En Revisión">En Revisión</option>
                          <option value="Rechazado">Rechazado</option>
                          <option value="Presentado">Presentado</option>
                          <option value="Cambio Chip">Cambio Chip</option>
                          <option value="Finalizado">Finalizado</option>
                          {cookie.get("tipoUsuarioId") === 1 && (
                            <option value="Anulado">Anulado</option>
                          )}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg="6">
                      <FormGroup>
                        <label>Tipo Gas</label>
                        <Input
                          type="select"
                          name="tipoGas"
                          value={data.tipoGas || ""}
                          onChange={handleChange}
                        >
                          <option value="">Seleccione</option>
                          <option value="GNV">GNV</option>
                          <option value="GLP">GLP</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button color="primary" type="submit">
                    Actualizar Orden
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <EditaVehiculoOrden idOrden={idOrden} />
      <EditaPropietarioOrden idOrden={idOrden} />
      <EditaEquiposOrden idOrden={idOrden} />
      <EditaAnexosOrden idOrden={idOrden} />
    </>
  );
};

export default EditaOrden;
